import { GetterTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { INotificationState } from './notification-state.store';

export const getters: GetterTree<INotificationState, IRootState> = {
  unreadNumber: (state: INotificationState) => state.unreadNumber,
  notifications: (state: INotificationState) => state.notifications,
  unreadNotifications: (state: INotificationState) => state.unreadNotifications,
  notificationIds: (state: INotificationState) => state.notifications.notifications.map(x => x.id),
  unreadNotificationIds: (state: INotificationState) => state.unreadNotifications.notifications.map(x => x.id),
}


// WEBPACK FOOTER //
// ./src/store/notification/notification-getters.store.ts